export const LOGO_URL = "/recoverydesk-logo.jpg";
export const LOGO_FULL_URL = "/recoverydesk-logo-full.png";

export const HERO_BG_URL =
    "https://images.unsplash.com/photo-1741356474357-72188f76e801?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGJsYWNrJTIwZ29sZCUyMHRleHR1cmV8ZW58MHx8fHwxNzgwNzg0NzI0fDA&ixlib=rb-4.1.0&q=85";

export const TRIAL_TEXTURE_URL =
    "https://images.pexels.com/photos/6141905/pexels-photo-6141905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const BUSINESS_CONTEXT_URL =
    "https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwYnVzaW5lc3MlMjBkYXJrfGVufDB8fHx8MTc4MDc4NDcyNHww&ixlib=rb-4.1.0&q=85";

export const CONTACT_EMAIL = "Recoverydeskai@outlook.com";
export const CONTACT_PHONE = "803-415-4553";
export const CONTACT_PHONE_HREF = "tel:+18034154553";
